export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_12.beecb056.jpg";